import { FLAVOR_INFO, parseFlavor, type FlavorInfo } from './flavorConfig'

/** Set at build time: `VITE_APP_FLAVOR=naforo|yiriba|suite` (default suite). */
export const FLAVOR: FlavorInfo = FLAVOR_INFO[parseFlavor(import.meta.env.VITE_APP_FLAVOR)]
